import * as THREE from 'three';

export const averagePosition = (points: readonly THREE.Vector3[]): THREE.Vector3 | null => {
    if (points.length === 0) return null;
    const sum = new THREE.Vector3();
    points.forEach((point) => sum.add(point));
    return sum.multiplyScalar(1 / points.length);
};
